module.exports = __webpack_public_path__ + "img/meal0.084f550e.svg";